import { slice } from './slice'

const assortmentAdvisorActions = {
  ...slice.actions,
}

export default assortmentAdvisorActions
